import { useState, useEffect } from 'react';

function getWindowWidthState() {
  // Проверяем, что window существует (для SSR/SSG)
  if (typeof window !== 'undefined') {
    return window.innerWidth;
  }
  return 0; // Или другое значение по умолчанию для серверной стороны
}

export default function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(getWindowWidthState());

  useEffect(() => {
    // Убедимся, что window существует
    if (typeof window === 'undefined') {
      return;
    }

    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
    // Вызываем handleResize сразу, чтобы установить начальное значение, если оно изменилось с момента SSR
    handleResize(); 

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
} 